import axios from 'axios';

export const baseUrl = `${window.location.origin}/api/v1`;
const api = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

export default api;
